import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import familyFestPickupLocationVehicleAPI from '@infrastructure/family-fest-pickup-location-vehicle-api';
export const FamilyFestGetVehiclesByPickupIdAsync = createAsyncThunk('FamilyFestVehicle/getVehicles', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupLocationVehicleAPI.FamilyFestGetVehiclesByPickupId(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const FamilyFestCreateVehicleAsync = createAsyncThunk('FamilyFestVehicle/create', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupLocationVehicleAPI.FamilyFestCreateVehicle(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const FamilyFestUpdateVehicleAsync = createAsyncThunk('FamilyFestVehicle/update', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupLocationVehicleAPI.FamilyFestUpdateVehicle(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const FamilyFestDeleteVehicleAsync = createAsyncThunk('FamilyFestVehicle/delete', async (id, { rejectWithValue }) => {
    try {
        await familyFestPickupLocationVehicleAPI.FamilyFestDeleteVehicle(id);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const FamilyFestGetVehiclesPaginatedAsync = createAsyncThunk('FamilyFestVehicle/getPaginated', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupLocationVehicleAPI.FamilyFestGetVehiclesPaginated(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFamilyFestVehicleByIdAsync = createAsyncThunk('FamilyFestVehicle/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupLocationVehicleAPI.FamilyFestGetVehicleById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
